import { useEffect, useRef, useState } from "react";
import { Upload, Download } from "lucide-react";
import { toast } from "sonner";
import { useSession } from "@/context/Session";
import { errMsg } from "@/lib/api";

export async function downloadDoc(api, id, filename) {
  try {
    const r = await api.get(`/documents/${id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = filename || "documento"; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) { toast.error("Download não autorizado ou indisponível."); }
}

export async function uploadDoc(api, file, category, extra = {}) {
  const fd = new FormData();
  fd.append("file", file); fd.append("category", category);
  Object.entries(extra).forEach(([k, v]) => v && fd.append(k, v));
  const { data } = await api.post("/documents/upload", fd);
  return data;
}

export const DocLink = ({ id, docs }) => {
  const { api } = useSession();
  const d = docs?.find((x) => x.id === id);
  if (!id) return <span className="text-[#587178]">—</span>;
  return <button type="button" data-testid={`doc-download-${id}`} onClick={() => downloadDoc(api, id, d?.filename)} className="inline-flex items-center gap-1 text-sm font-semibold text-[#2a8f86] hover:underline"><Download className="h-3.5 w-3.5" />{d?.filename || "Baixar"}</button>;
};

export function DocField({ value, onChange, category = "outro", name }) {
  const { api } = useSession();
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  useEffect(() => { api.get("/documents").then((r) => setDocs(r.data)).catch(() => {}); }, [api]);
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try { const d = await uploadDoc(api, f, category); setDocs([d, ...docs]); onChange(d.id); toast.success("Arquivo enviado"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex gap-2">
      <select data-testid={`field-${name}`} className="field" value={value || ""} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">Nenhum documento</option>
        {docs.map((d) => <option key={d.id} value={d.id}>{d.filename}</option>)}
      </select>
      <input ref={ref} type="file" hidden onChange={onFile} data-testid={`field-${name}-file`} />
      <button type="button" className="btn-ghost shrink-0" onClick={() => ref.current.click()} disabled={busy}><Upload className="h-4 w-4" />{busy ? "..." : "Enviar"}</button>
    </div>
  );
}
